import { render, staticRenderFns } from "./index.vue?vue&type=template&id=85a73588&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=85a73588&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a73588",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {JtecBreadcrumb: require('/usr/src/app/components/ui/Breadcrumb.vue').default,JtecShare: require('/usr/src/app/components/ui/Share.vue').default,JtecSelector: require('/usr/src/app/components/ui/Selector.vue').default,JtecPager: require('/usr/src/app/components/ui/Pager.vue').default})
